import { render, staticRenderFns } from "./HospitalView.vue?vue&type=template&id=3cf25b32"
import script from "./HospitalView.vue?vue&type=script&lang=js"
export * from "./HospitalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports